import { Button, Col, Form, Input, message, Row, Typography } from "antd";
import { AdminUser, sendInvite } from "apis/auth.api";
import CenteredSpin from "components/shared/CenteredSpin";
import ErrorResult from "components/shared/ErrorResult";
import PageTitle from "components/shared/PageTitle";
import { useMe } from "hooks/Common.query";
import React from "react";
import { displayErrorMessage } from "utils/messageHelper";

interface Props {}

const Invite = (props: Props) => {
  const { data, isError, error, isFetching } = useMe();

  if (isError) {
    return <ErrorResult error={error} />;
  }

  if (isFetching) {
    return <CenteredSpin />;
  }

  const onFinish = (values: AdminUser) => {
    sendInvite(values)
      .then(() => message.success("Meghívó sikeresen elküldve"))
      .catch(displayErrorMessage);
  };

  return (
    <>
      <PageTitle text="Meghívó küldése" />
      <Row gutter={24}>
        <Col xs={24} lg={12}>
          <Form
            initialValues={{ partnerId: data?.partnerId }}
            onFinish={onFinish}
            labelCol={{ span: 8 }}
            className="flex-1"
          >
            <Form.Item
              label="Email cím"
              name="email"
              rules={[
                { required: true, message: "Kérjük adj meg email címet!" },
              ]}
            >
              <Input type="email" />
            </Form.Item>

            <Form.Item label="Partner azonosító" name="partnerId">
              <Input disabled={!data?.superuser} />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8 }}>
              <Button type="primary" htmlType="submit">
                Meghívás
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col xs={24} lg={12}>
          <div className="bg-gray-800 px-12 py-8">
            <Typography.Text>
              Meghívhatod csapattagjaidat a szervezetedbe (
              <span className="text-red-300">Partner azonosító</span>). <br />
              Egy emailt fognak kapni, benne a regisztrációs oldalunkra vezető linkkel, ahol meg kell adják a jelszavukat. <br />
              Egy meghívó{" "}
              <span className="text-red-300">7 napig</span> érvényes és csak egyszer használható fel.
            </Typography.Text>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Invite;
